import React, { useMemo } from 'react'

import { CURRENCIES, DEFAULT_CURRENCY } from '../../constants'
import { COLORS } from '../../styles'

import Styled from './PricePerPortionBadge.styled'

const PricePerPortionBadge = ({
  backgroundColor,
  className,
  currency,
  isFull,
  label,
  level,
  textColor,
}) => {
  const config = useMemo(() => {
    const unit =
      CURRENCIES?.[currency]?.symbol || CURRENCIES[DEFAULT_CURRENCY].symbol
    return { unit, symbols: unit.repeat(level), label }
  }, [currency, level, label])

  return (
    <Styled className={className}>
      <Styled.container title={config.label}>
        <svg
          width="53"
          height="32"
          viewBox="0 0 53 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {
            {
              1: (
                <path
                  d="M28.4734 3.12238C29.2967 4.00952 30.5137 4.41277 31.7039 4.17082C33.6905 3.77654 35.5966 5.15654 35.8292 7.17279C35.9724 8.37357 36.7241 9.42202 37.8248 9.92384C39.6682 10.7751 40.3931 13.0154 39.3998 14.7808C38.8092 15.8382 38.8092 17.1286 39.3998 18.186C40.3931 19.9603 39.6682 22.1916 37.8248 23.0429C36.7241 23.5537 35.9724 24.5931 35.8292 25.7939C35.5966 27.8102 33.6905 29.1902 31.7039 28.7959C30.5137 28.5629 29.2967 28.9572 28.4734 29.8443C27.0954 31.3319 24.7508 31.3319 23.3727 29.8443C22.5494 28.9572 21.3324 28.5539 20.1422 28.7959C18.1556 29.1902 16.2496 27.8102 16.0169 25.7939C15.8737 24.5931 15.122 23.5447 14.0214 23.0429C12.1779 22.1916 11.4531 19.9513 12.4464 18.186C13.037 17.1286 13.037 15.8382 12.4464 14.7808C11.4531 13.0065 12.1779 10.7751 14.0214 9.92384C15.122 9.41306 15.8737 8.37357 16.0169 7.17279C16.2496 5.15654 18.1556 3.77654 20.1422 4.17082C21.3324 4.40381 22.5494 4.00952 23.3727 3.12238C24.7508 1.62587 27.1043 1.62587 28.4734 3.12238Z"
                  fill={backgroundColor}
                />
              ),
              2: (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.0744 4.10772C24.4707 3.93531 23.9153 3.59855 23.4734 3.12238C22.1043 1.62587 19.7508 1.62587 18.3727 3.12238C17.5494 4.00952 16.3324 4.40381 15.1422 4.17082C13.1556 3.77654 11.2496 5.15654 11.0169 7.17279C10.8737 8.37358 10.122 9.41306 9.02136 9.92384C7.17793 10.7751 6.45309 13.0065 7.44639 14.7808C8.037 15.8382 8.037 17.1286 7.44639 18.186C6.45309 19.9513 7.17793 22.1916 9.02136 23.0429C10.122 23.5447 10.8737 24.5931 11.0169 25.7939C11.2496 27.8102 13.1556 29.1902 15.1422 28.7959C16.3324 28.5539 17.5494 28.9572 18.3727 29.8443C19.7508 31.3319 22.0954 31.3319 23.4734 29.8443C23.9192 29.3641 24.4803 29.0282 25.09 28.8582C25.2537 28.8493 25.4188 28.8288 25.5845 28.7959C25.7568 28.7609 25.9296 28.7394 26.1017 28.7309C26.3019 28.7352 26.5033 28.7566 26.7039 28.7959C26.8749 28.8298 27.0453 28.8506 27.2141 28.859C27.8178 29.0314 28.3731 29.3682 28.815 29.8443C30.1931 31.3319 32.5376 31.3319 33.9157 29.8443C34.739 28.9572 35.956 28.5629 37.1462 28.7959C39.1328 29.1902 41.0389 27.8102 41.2715 25.7939C41.4147 24.5931 42.1664 23.5537 43.2671 23.0429C45.1105 22.1916 45.8354 19.9603 44.8421 18.186C44.2514 17.1286 44.2514 15.8382 44.8421 14.7808C45.8354 13.0154 45.1105 10.7751 43.2671 9.92384C42.1664 9.42202 41.4147 8.37358 41.2715 7.17279C41.0389 5.15654 39.1328 3.77654 37.1462 4.17082C35.956 4.41277 34.739 4.00952 33.9157 3.12238C32.5466 1.62587 30.1931 1.62587 28.815 3.12238C28.3693 3.60266 27.8082 3.93848 27.1984 4.10853C27.0348 4.11739 26.8696 4.13794 26.7039 4.17082C26.5317 4.20584 26.3589 4.22734 26.1868 4.23582C25.9866 4.23155 25.7852 4.2101 25.5845 4.17082C25.4135 4.13689 25.2432 4.1161 25.0744 4.10772Z"
                  fill={backgroundColor}
                />
              ),
              3: (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M31.5974 3.23962C31.7891 3.23167 31.9817 3.20992 32.1736 3.17382C32.34 3.14325 32.506 3.12333 32.6706 3.11354C33.3602 2.94392 33.9948 2.60685 34.4986 2.12393C36.0497 0.625358 38.6986 0.625358 40.2396 2.12393C41.1662 3.0123 42.536 3.41611 43.8756 3.17382C46.1116 2.77899 48.257 4.1609 48.5188 6.17993C48.68 7.38238 49.526 8.43227 50.7649 8.93479C52.8397 9.78727 53.6556 12.0306 52.5376 13.7984C51.8728 14.8573 51.8728 16.1495 52.5376 17.2083C53.6556 18.9851 52.8397 21.2195 50.7649 22.0719C49.526 22.5834 48.68 23.6243 48.5188 24.8268C48.257 26.8458 46.1116 28.2277 43.8756 27.8329C42.536 27.5996 41.1662 27.9944 40.2396 28.8828C38.6885 30.3724 36.0497 30.3724 34.4986 28.8828C33.9994 28.4043 33.3717 28.0664 32.6894 27.8943C32.5186 27.8849 32.3464 27.8646 32.1736 27.8329C31.9365 27.79 31.6985 27.7683 31.4624 27.7671C31.2628 27.775 31.0623 27.7968 30.8626 27.8329C30.7315 27.856 30.6008 27.8731 30.4707 27.8842C29.7939 28.0508 29.1704 28.3912 28.6774 28.8828C27.186 30.3724 24.6486 30.3724 23.1572 28.8828C22.4758 28.2035 21.5453 27.8075 20.5691 27.7671C19.5377 27.7728 18.5451 28.1681 17.8283 28.8828C16.3369 30.3724 13.7995 30.3724 12.3081 28.8828C11.4171 27.9944 10.1 27.5906 8.8119 27.8329C6.66191 28.2277 4.59908 26.8458 4.34728 24.8268C4.19232 23.6243 3.37881 22.5745 2.1876 22.0719C0.192566 21.2195 -0.59189 18.9761 0.483105 17.2083C1.12229 16.1495 1.12229 14.8573 0.483105 13.7984C-0.59189 12.0217 0.192566 9.78727 2.1876 8.93479C3.37881 8.4233 4.19232 7.38238 4.34728 6.17993C4.59908 4.1609 6.66191 2.77899 8.8119 3.17382C10.1 3.40713 11.4171 3.0123 12.3081 2.12393C13.7995 0.625358 16.3466 0.625358 17.8283 2.12393C18.5096 2.80327 19.4402 3.19925 20.4163 3.23964C21.4477 3.23389 22.4403 2.83863 23.1572 2.12393C24.6486 0.625358 27.1956 0.625358 28.6774 2.12393C29.165 2.61015 29.7803 2.95121 30.4487 3.12064C30.586 3.13174 30.7241 3.14937 30.8626 3.17382C31.1075 3.21648 31.3534 3.23814 31.5974 3.23962Z"
                  fill={backgroundColor}
                />
              ),
            }[isFull ? 3 : level]
          }
        </svg>

        {isFull ? (
          <Styled.unit>
            <Styled.unitPart isActive={level >= 1}>
              {config.unit}
            </Styled.unitPart>
            <Styled.unitPart isActive={level >= 2}>
              {config.unit}
            </Styled.unitPart>
            <Styled.unitPart isActive={level >= 3}>
              {config.unit}
            </Styled.unitPart>
          </Styled.unit>
        ) : (
          <Styled.unit textColor={textColor}>{config.symbols}</Styled.unit>
        )}
      </Styled.container>
    </Styled>
  )
}

PricePerPortionBadge.defaultProps = {
  level: 1,
  currency: DEFAULT_CURRENCY,
  backgroundColor: COLORS.cobalt,
  textColor: COLORS.white,
}

export default PricePerPortionBadge
